module.exports = __webpack_public_path__ + "static/media/email_arrow.dbe50efc.svg";